<div class="admissions-manager-sankey-flow-view-part">
	This is admissions-manager-page sankey-flow view
</div>